<!--page starts-->
<section class="page-wrapper">
    <section class="vitalityblast-hero-section margin-top-152 cf">
        <div class="club-fischer-bottom-contact-section">
            <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/vitality-banner.png);">
                <div class="container">
                    <div class="titel-box">
                        <h2 class="titel-name">Claim your Support Your County 2023 tickets</h2>
                        <p>Leicestershire v Glamorgan 27th – 30th April 2023</p>
                        <p>*Tickets are limited and subject to availability</p>
                    </div>
                    <div class="commercial-bottom-contact-detail">
                        <form class="commercialform" #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                            <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                            </http-message>
                            <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                               class="err-msg-block"></http-message>
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-input half mr-30">
                                    <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                               class="app-group">
                                        <input appFieldInput tabindex="1" class="register-style" placeholder="First Name *" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                               class="app-group">
                                        <input appFieldInput tabindex="1" class="register-style" placeholder="Last Name *" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input full">
                                    <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                               class="app-group">
                                        <input appFieldInput tabindex="2" class="register-style" placeholder="Email Address *" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half mr-30">
                                    <div class="custom-select" class="register-vitality">
                                        <select id="choose_your_day">
                                          <option value="">Choose Your Day</option>
                                          <option value="Thursday 27th April">Thursday 27th April</option>
                                          <option value="Friday 28th April">Friday 28th April</option>
                                          <option value="Saturday 29th April">Saturday 29th April</option>
                                          <option value="Sunday 30th April">Sunday 30th April</option>
                                        </select>
                                    </div>
                                    <div class="invalid-feedback  attnderror" id="select_match-msg">Please choose your day</div>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <div class="custom-select" class="register-vitality">
                                        <select id="number_of_tickets_claimed">
                                          <option value="">Number of tickets claimed</option>
                                          <option value="1">1</option>
                                          <option value="2">2</option>
                                          <option value="3">3</option>
                                          <option value="4">4</option>
                                          <option value="5">5</option>
                                          <option value="6">6</option>
                                          <option value="7">7</option>
                                          <option value="8">8</option>
                                          <option value="9">9</option>
                                          <option value="10">10</option>
                                        </select>
                                    </div>
                                    <div class="invalid-feedback  attnderror" id="select_match-msg">Please choose number of tickets claimed</div>
                                </div>
                                <div class="join-register-right-box-input">
                                    <app-form-field name="email" [(ngModel)]="contactRequest.where_did_you_hear_about"
                               class="app-group">
                                        <input appFieldInput tabindex="2" class="register-style" placeholder="Where did you hear about #SUPPORTYOURCOUNTY 2023?" type="text">
                                    </app-form-field>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-btn"><button  tabindex="11" id="reg_button" type="submit">REGISTER</button></div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="commercial-bottom-contact-overlay"></div>
            </div>
        </div>
    </section>
</section><!-- page ends-->